<template>
  <svg
    width="18"
    height="13"
    viewBox="0 0 22 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M2 0C0.89 0 0 0.89 0 2V10H2C2 10.7956 2.31607 11.5587 2.87868 12.1213C3.44129 12.6839 4.20435 13 5 13C5.79565 13 6.55871 12.6839 7.12132 12.1213C7.68393 11.5587 8 10.7956 8 10H14C14 10.7956 14.3161 11.5587 14.8787 12.1213C15.4413 12.6839 16.2044 13 17 13C17.7956 13 18.5587 12.6839 19.1213 12.1213C19.6839 11.5587 20 10.7956 20 10H22V6C22 4.89 21.11 4 20 4L17 0H2ZM14 1.5H16.5L18.46 4H14V1.5ZM5 8.5C5.39782 8.5 5.77936 8.65804 6.06066 8.93934C6.34196 9.22064 6.5 9.60218 6.5 10C6.5 10.3978 6.34196 10.7794 6.06066 11.0607C5.77936 11.342 5.39782 11.5 5 11.5C4.60218 11.5 4.22064 11.342 3.93934 11.0607C3.65804 10.7794 3.5 10.3978 3.5 10C3.5 9.60218 3.65804 9.22064 3.93934 8.93934C4.22064 8.65804 4.60218 8.5 5 8.5ZM17 8.5C17.3978 8.5 17.7794 8.65804 18.0607 8.93934C18.342 9.22064 18.5 9.60218 18.5 10C18.5 10.3978 18.342 10.7794 18.0607 11.0607C17.7794 11.342 17.3978 11.5 17 11.5C16.6022 11.5 16.2206 11.342 15.9393 11.0607C15.658 10.7794 15.5 10.3978 15.5 10C15.5 9.60218 15.658 9.22064 15.9393 8.93934C16.2206 8.65804 16.6022 8.5 17 8.5Z"
      fill="#B7BDCD"
    />
  </svg>
</template>

<script>
export default {};
</script>

<style></style>
